import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  stopLeadStatusPollAction,
  getLeadStatusAction,
} from '../actionCreators';

const useLeadStatusPoll = ({ shouldPoll }) => {
  const dispatch = useDispatch();

  const submissionId = useSelector((store) => store.submission?.id);
  const token = useSelector((store) => store.submission?.token);

  useEffect(() => {
    if (!shouldPoll || !submissionId || !token) return undefined;

    dispatch(getLeadStatusAction({ submissionId, token }));

    return () => {
      dispatch(stopLeadStatusPollAction());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldPoll, submissionId, token]);
};

export default useLeadStatusPoll;
